function buildUrgentMessage({ t, token }) {
  const translationKeys = {
    PickupWithinHours: 'pickup_within_hours',
    PickupToday: 'pickup_today',
    PickupTomorrow: 'pickup_tomorrow',
    Other: 'other',
  };

  const translationKey = translationKeys[token?.type];

  return translationKey
    ? t(`urgency_message_specification.${translationKey}`, {
        ...token.params,
      })
    : '';
}

export default buildUrgentMessage;
